import { YouTubeVideo as YouTubeVideoZDS } from '@zapier/design-system';
import { FC } from 'react';

type Props = {
  allowFullscreen: boolean;
  aspectRatio: number;
  autoplay: boolean;
  title: string;
  youtubeId: string;
};

export const YouTubeVideo: FC<Props> = ({
  allowFullscreen,
  aspectRatio,
  autoplay,
  title,
  youtubeId,
}) => (
  <YouTubeVideoZDS
    allowFullscreen={allowFullscreen}
    aspectRatio={aspectRatio}
    autoplay={autoplay}
    title={title}
    youTubeId={youtubeId}
  />
);
